import { PostEditorPostError, PostEditorPostErrors, PostGroupsType } from '../../../models/post-editor';
import { ErrorMessageSeverity } from '../../../constants/form';
import { PostTiming } from '../../../models/graphql';
import { getCachedProfiles, SocialProfileInputValue } from '../helpers/getCachedProfiles';
import { PostEditorValidationMessages } from '../constants/validation-messages';
import { SelectedSocialProfileValue } from '../../../components/socialProfiles/SocialProfileSelectorList/SocialProfileSelectorList.view';
import { isSocialProfileTypenameGuard } from '../helpers/guards';
import { severityResolver } from './helpers/severity-resolver';

export const preventPostNowForDisconnected = (
  postGroup: PostGroupsType,
  severity: ErrorMessageSeverity
): PostEditorPostErrors => {
  const { customizeSchedulePerProfile, profiles } = postGroup;
  let results: PostEditorPostError[] = [];
  if (customizeSchedulePerProfile) {
    postGroup.posts.forEach(post => {
      const { postTiming } = post.scheduling;
      const selectedSocialProfiles: SelectedSocialProfileValue[] = profiles.filter(
        p => p.profileId === post.customizedProfileId
      );
      if (selectedSocialProfiles.length && postTiming === PostTiming.NOW) {
        const profileInputArgs: SocialProfileInputValue[] = selectedSocialProfiles.flatMap(p =>
          isSocialProfileTypenameGuard(p.__typename)
            ? {
                id: p.profileId,
                type: p.__typename
              }
            : []
        );
        results = [
          ...results,
          ...getCachedProfiles(profileInputArgs).flatMap(profile =>
            profile.connected
              ? []
              : {
                  profileId: profile.id,
                  variationId: null,
                  severity: severityResolver(post, severity),
                  selectedSocialProfiles,
                  message: PostEditorValidationMessages.preventPostNowForDisconnected
                }
          )
        ];
        results = [
          ...results,
          ...getCachedProfiles(profileInputArgs).flatMap(profile =>
            profile.connected
              ? []
              : {
                  profileId: profile.id,
                  variationId: null,
                  severity: severityResolver(post, severity),
                  selectedSocialProfiles,
                  message: PostEditorValidationMessages.preventPostNowForDisconnected
                }
          )
        ];
      }
    });
    return results.length ? results : false;
  } else {
    const { postTiming } = postGroup.groupPostAttributes.scheduling;
    if (postTiming === PostTiming.NOW) {
      const profileInputArgs: SocialProfileInputValue[] = profiles.flatMap(p =>
        isSocialProfileTypenameGuard(p.__typename) ? { id: p.profileId, type: p.__typename } : []
      );
      if (getCachedProfiles(profileInputArgs).filter(p => !p.connected).length) {
        return {
          profileId: null,
          variationId: null,
          severity: severityResolver(postGroup.groupPostAttributes, severity),
          selectedSocialProfiles: [],
          message: PostEditorValidationMessages.preventPostNowForDisconnected
        };
      }
    }
    return false;
  }
};
